import { render } from "./subAccCreate.vue?vue&type=template&id=66d27f83"
import script from "./subAccCreate.vue?vue&type=script&lang=js"
export * from "./subAccCreate.vue?vue&type=script&lang=js"

import "./subAccCreate.vue?vue&type=style&index=0&id=66d27f83&lang=scss"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__